import React, { useState, useRef, useContext, useEffect } from 'react';
import * as XLSX from 'xlsx';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';
import moment from 'moment';
import { AuthContext } from '@shared/context/AuthContext';
import Button from 'react-bootstrap/Button';
import Lists from '@shared/component/Lists';
import CustomDateTimePicker from '@shared/component/DatePicker';
import { DateFormatPicker } from '@utils/static/commonUtils';
import FilterModule from './filter';
import { saveAs } from 'file-saver';
interface FormData {
    name?: null;
    // Add more fields as needed
}
export function TransporterReport() {
    const min = new Date('2023-01-09');
    const [errors, setError] = useState<any>({
        name: {
            required: true,
            error: true,
            message: 'Please enter name',
            pattern: /^[A-Za-z][A-Za-z0-9\s.&]*$/, ///^[A-Za-z0-9\s]*$/,
            maxLength: 50,
        },
    });
    const listRef: any = useRef(null);
    const currentDate = new Date();
    const { setLoader } = useContext(AuthContext);
    const [report, setReport] = useState({
        startDate: null,
        endDate: null,
    });
    const [demand, setDemnad] = useState([]);
    const [locationData, setLocationData] = useState([]);
    const [isSubmit, setIsSubmit] = useState(false);
    const [recordCount, setRecordCount] = useState(0);
    const [showList, setShowList] = useState(false);
    const [allBids, setAllBids] = useState([]);
    const [showFilterDemand, setShowFilterDemand] = useState(false);
    const [existingState, setExistingState] = useState({});
    const [excelDataExport, setExcelDataExport] = useState({
        excelDataDemand: [],
        excelDataBids: []
    })

    const [columns, setColumns] = useState({
        'demand.id': 'Demand ID',
        'app_user.companyname': 'Transporter Company Name',
        'app_user.phone': 'Number',
        deliveryStatus: 'Status',
        actualDeliveryDate: 'Actual Pickup Date',
        // createdAt: 'Demand Created Date',
        'demand.from.city': 'Pickup Location',
        deliveredDeliveryDate: 'Actual Delivery Date',
        'demand.to.city': 'Delivery Location',
        'demand.weight': 'Weight',
        'demand.itemUnit': 'Unit',
        rate: 'Bid Amount (Rs.)',
        'demand.createdAt': 'Demand Created Date',
    });



    const handleExport = () => {
        try {

            const element = document.getElementById('excel-table');
            const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();

            const data: any = allBids;
            const ws2 = XLSX.utils.json_to_sheet(data);

            XLSX.utils.book_append_sheet(wb, ws, 'Demands');
            XLSX.utils.book_append_sheet(wb, ws2, `Bids`);
            /* save to file */

            XLSX.writeFile(wb, 'demand_data.xlsx');
            // exportBids();
        } catch (error) { }
    };

    const exportBids = () => {
        try {
            const data: any = allBids;
            const demandId = ''; //data?.[0]?.['Demand Id'] || '';

            const ws = XLSX.utils.json_to_sheet(data);
            // Freeze the first row
            ws['!freeze'] = {
                xSplit: 0,
                ySplit: 1,
                topLeftCell: 'A2',
                activePane: 'bottomRight',
                state: 'frozen',
            };

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, ws, `Demand_Bids_Data.xlsx`);
            XLSX.writeFile(workbook, `Demand_Bids_Data.xlsx`);
        } catch (error) { }
    };

    // handle Filter modal
    // filter model hide and show
    const handelFilterModal = (flag: boolean) => {
        try {
            setShowFilterDemand(flag);
        } catch (error) { }
    };

    // get Data form props data
    const handleSendData = (data, state) => {
        setExistingState(state);
        setDemnad(data.data.data);
        getAllBids(data?.data?.data || []);
        setRecordCount(data?.data?.count || 0);
    };

    const searchCategory = async (value: any, page: any = 1) => {
        const start = moment(report.startDate).format('YYYY-MM-DD');
        const end = moment(report.endDate).format('YYYY-MM-DD');

        try {
            //if (demand?.length > 0) {
            const data = await APIService.getAll(
                `report/search?page=${page}&order=desc&startDate=${start}&endDate=${end}&search=${value}`,
                true,
                false,
            );
            setDemnad(data.data.data);
            setRecordCount(data?.data?.count || 0);
            // } else {
            //     setDemnad([]);
            // }
            getAllBids(data?.data?.data || []);
        } catch (err) { }
    };

    const handleMultipleExport = (dataDemand, bidList) => {
        try {
            let mergedBids = [];

            bidList.forEach((item) => {
                if (item?.demand?.bids) {
                    const updatedBids = item.demand.bids.map(bid => ({
                        'Demand Id': bid.demandId,
                        'Bid Id': bid.id,
                        'Transporter Name': bid?.app_user?.name,
                        'Bidding Date & Time': DateFormatPicker(bid?.createdAt, 'DD-MMM-YYYY hh:mm A'),
                        'Amount (Rs.)': bid?.rate || '',
                        'Delivery Date & Time': DateFormatPicker(bid?.expectedDeliveryDate, 'DD-MMM-YYYY hh:mm A'),
                        'Status':
                            bid.status === 'winner'
                                ? 'Winner'
                                : bid.status === 'cancelled'
                                    ? 'Cancelled'
                                    : bid.status === 'running'
                                        ? 'Running'
                                        : bid.status === 'onHold'
                                            ? 'On Hold'
                                            : 'Pending',
                    }));

                    mergedBids = [...mergedBids, ...updatedBids];
                }
            });
            // ✅ Prepare Demand
            const formattedDemand = dataDemand.map(item => ({
                'Demand ID': item?.demand?.id,
                'Transporter Company Name': item?.app_user?.companyname,
                'Number': item?.app_user?.phone,
                'Status': item?.deliveryStatus,
                'Actual Pickup Date': DateFormatPicker(item?.actualDeliveryDate, 'DD-MMM-YYYY'),
                'Pickup Location': item?.demand?.from?.city,
                'Actual Delivery Date': DateFormatPicker(item?.deliveredDeliveryDate, 'DD-MMM-YYYY'),
                'Delivery Location': item?.demand?.to?.city,
                'Weight': item?.demand?.weight,
                'Unit': item?.demand?.itemUnit,
                'Bid Amount (Rs.)': item?.rate,
                'Demand Created Date': DateFormatPicker(item?.demand?.createdAt, 'DD-MMM-YYYY'),
            }));

            // ✅ Create Workbook
            const workbook = XLSX.utils.book_new();
            console.log(mergedBids, 'mergedBids')

            // ✅ Sheet 1: Demand
            const demandSheet = XLSX.utils.json_to_sheet(formattedDemand);
            XLSX.utils.book_append_sheet(workbook, demandSheet, 'Demands');

            // ✅ Sheet 2: Bids
            const bidsSheet = XLSX.utils.json_to_sheet(mergedBids);
            XLSX.utils.book_append_sheet(workbook, bidsSheet, 'Bids');

            // ✅ Export File
            const excelBuffer = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'array',
            });

            const fileData = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            saveAs(fileData, `Demand_Bids_Report.xlsx`);

        } catch (error) {
            console.error('Export Error:', error);
        }
    };

    const getAllExportData = async (get: any = 1) => {
        try {
            if (report.startDate == null) {
                Notify('error', 'Please choose start date');
                return;
            }
            if (report.endDate == '') {
                Notify('error', 'Please choose end date');
                return;
            }
            const start = moment(report?.startDate).format('YYYY-MM-DD');
            const end = moment(report?.endDate).format('YYYY-MM-DD');

            if (start > end) {
                Notify('error', 'Please select end date grater than the start date');
                return;
            }

            setLoader(true);
            // const limit = 100000000000
            const key = 'all'
            const queryString = `page=${get}&sort=createdAt&startDate=${start}&endDate=${end}&key=${key}`;
            const url = `report?${queryString}`;
            const data = await APIService.getAll(url, true, false);

            setExcelDataExport({
                excelDataBids: data?.data?.data,
                excelDataDemand: data?.data?.data
            })

            const dataDemand = data?.data?.data
            const bidList = data?.data?.data

            // Handle Excel
            handleMultipleExport(dataDemand, bidList)
            // setDemnad(data.data.data);
            // getAllBids(data?.data?.data || []);
            // setRecordCount(data?.data?.count || 0);

            // setShowList(true);
            setLoader(false);

        } catch (err) {
            setLoader(false);
        }
    };

    const getAllBids = (data: any) => {
        try {
            let mergedBids = [];

            // Iterate over each item in the data array
            data.forEach((item, k) => {
                // Check if demands and bids exist
                if (item?.demand?.bids) {
                    // Merge the current bids into the mergedBids array
                    const updatedBids = item.demand.bids.map(bid => ({
                        'Demand Id': bid.demandId,
                        'Bid Id': bid.id,
                        'Transporter Name': bid?.app_user?.name,
                        'Bidding Date & Time': DateFormatPicker(bid?.createdAt, 'DD-MMM-YYYY hh:mm A'),
                        'Amount (Rs.)': bid?.rate || '',
                        'Delivery Date & Time': DateFormatPicker(bid?.expectedDeliveryDate, 'DD-MMM-YYYY hh:mm A'),
                        Status:
                            bid.status == 'winner'
                                ? 'Winner'
                                : bid.status == 'cancelled'
                                    ? 'Cancelled'
                                    : bid.status == 'running'
                                        ? 'Running'
                                        : bid.status == 'onHold'
                                            ? 'On Hold'
                                            : 'Pending',
                    }));
                    // Merge the updated bids into the mergedBids array
                    mergedBids = mergedBids.concat(updatedBids);
                }

                if (k == data.length - 1) {
                    setAllBids(mergedBids);
                }
            });
        } catch (error) { }
    };

    const getValue = (e: any) => {
        try {
            const data = { ...report, ...e };
            setReport(data);
        } catch (error) { }
    };

    const GetFinalizedDemand = async (get: any = 1) => {
        try {
            if (report.startDate == null) {
                Notify('error', 'Please choose start date');
                return;
            }
            if (report.endDate == '') {
                Notify('error', 'Please choose end date');
                return;
            }
            const start = moment(report?.startDate).format('YYYY-MM-DD');
            const end = moment(report?.endDate).format('YYYY-MM-DD');

            if (start > end) {
                Notify('error', 'Please select end date grater than the start date');
                return;
            }

            setLoader(true);
            const queryString = `page=${get}&sort=createdAt&startDate=${start}&endDate=${end}`;
            const url = `report?${queryString}`;
            const data = await APIService.getAll(url, true, false);
            setDemnad(data.data.data);
            getAllBids(data?.data?.data || []);
            setRecordCount(data?.data?.count || 0);

            setShowList(true);
            setLoader(false);
            listRef.current.clearSearchBox(true);
        } catch (err) {
            setLoader(false);
        }
    };

    // get All Location

    const getLocation = async () => {
        try {
            setLoader(true);
            const data = await APIService.getAll('location/?page=1&sort=createdAt&type=active', true, false);
            setLoader(false);
            setLocationData(data?.data?.data);
        } catch (err) {
            setLoader(false);
        }
    };



    useEffect(() => {
        getLocation();
    }, []);

    return (
        <div className="container dash-container">
            <div className="dash_bread_box">
                <ul>
                    <li>Transporter Report</li>
                </ul>
            </div>
            <div className="content_body_cover">
                <div className="row">
                    <div className="col-sm-5">
                        <div className="form-floating">
                            <CustomDateTimePicker
                                data={{
                                    name: 'startDate',
                                    placeholder: 'Select Date',
                                    label: 'Start Date',
                                    type: 'datetime-local',
                                    id: 'floatingInput',
                                }}
                                date={min}
                                minDate={min}
                                maxDate={currentDate}
                                controlName="startDate"
                                isSubmit={isSubmit}
                                value={report.startDate}
                                setValue={(e: any) => getValue(e, 'startDate')}
                                inputProps={errors}
                                showTimeSelect={false}
                            />
                        </div>
                    </div>
                    <div className="col-sm-5">
                        <div className="form-floating">
                            <CustomDateTimePicker
                                data={{
                                    name: 'endDate',
                                    placeholder: 'Select Date',
                                    label: 'End Date',
                                    type: 'datetime-local',
                                    id: 'floatingInput',
                                }}
                                date={min}
                                minDate={min}
                                maxDate={currentDate}
                                controlName="endDate"
                                isSubmit={isSubmit}
                                value={report.endDate}
                                setValue={(e: any) => getValue(e, 'endDate')}
                                inputProps={errors}
                                showTimeSelect={false}
                            />
                        </div>
                    </div>
                    <div className="col-sm-2">
                        <Button
                            variant="secondary"
                            className="full_width_btn btn dark_btn custom_btn"
                            onClick={() => GetFinalizedDemand()}
                        >
                            Search
                        </Button>
                    </div>
                </div>
                <br></br>
                <br></br>

                {showFilterDemand && (
                    <FilterModule
                        handelFilterModal={(e: boolean) => handelFilterModal(e)}
                        locationData={locationData}
                        checkData={existingState}
                        sendData={(data, state) => handleSendData(data, state)}
                        storeDate={report}
                    />
                )}
                {showList && (
                    <Lists
                        handleExport={getAllExportData}
                        ref={listRef}
                        headers={columns}
                        data={demand}
                        searchItem={searchCategory}
                        type={'report'}
                        recordCount={recordCount}
                        handelFilterModal={(e: boolean) => handelFilterModal(e)}
                        callPagination={GetFinalizedDemand}
                        filterText="Filter"
                        showFilterButton={true}
                        helperText={'Search By Company Name, Number, Status, Pickup Location, Delivery Location'}
                        filterDataObj={existingState}
                        toolTipDescription={"It exports data from start date to end date"}
                    />
                )}
            </div>
        </div>
    );
}
